import SiteLayout from "@/components/feature/SiteLayout";
import PageHero from "@/components/feature/PageHero";
import CTASection from "@/components/feature/CTASection";

const FEATURES = [
  {
    title: "고응답 제어",
    desc: "입력 명령에 따라 서보밸브가 신속하게 유량과 방향을 조절합니다.",
  },
  {
    title: "정밀 위치 제어",
    desc: "실린더의 움직임을 정밀하게 제어하여 안정적인 장비 동작을 구현합니다.",
  },
  {
    title: "실시간 피드백",
    desc: "위치센서의 실제값을 컨트롤러로 되돌려 오차를 지속적으로 보정합니다.",
  },
];

const LOOP_IMAGE =
  "https://storage.helloreaddy.io/project_files/d69eff6a-141f-4a4c-87b1-85937ec8d7bf/eb3a5983-74b8-4b57-8631-71f9437b0da2_compressed_unnamed.webp";

export default function ServoHydraulicPage() {
  return (
    <SiteLayout>
      <PageHero
        eyebrow="Servo Hydraulic"
        title="Servo Hydraulic Control System"
        subtitle="서보밸브, 비례밸브, 유압 실린더, HPU, 센서, 모션컨트롤러를 기반으로 한 정밀 유압 제어 시스템"
        crumbs={[{ label: "HOME", to: "/" }, { label: "Servo Hydraulic" }]}
        imageUrl="https://readdy.ai/api/search-image?query=Industrial%20servo%20hydraulic%20control%20cabinet%20with%20servo%20valve%20stack%20on%20manifold%20block%2C%20clean%20modern%20factory%2C%20cool%20industrial%20lighting%2C%20detailed%20mechanical%20textures%2C%20editorial%20B2B%20engineering%20photography%2C%20muted%20steel%20gray%20and%20cool%20blue%20palette&width=1920&height=900&seq=mctech-servohydraulic-hero-01&orientation=landscape"
      />

      <section className="py-16 md:py-24 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          {/* Eyebrow */}
          <div className="text-center mb-4">
            <span className="text-xs md:text-sm font-semibold tracking-[0.25em] uppercase text-accent-600">
              SERVO HYDRAULIC CONTROL
            </span>
          </div>

          {/* Title */}
          <h2 className="text-center text-2xl md:text-4xl font-heading font-extrabold text-foreground-950 mb-6">
            서보밸브 중심의 정밀 폐루프 제어
          </h2>

          {/* Description */}
          <div className="max-w-[800px] mx-auto text-center mb-12 md:mb-16">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              모션 컨트롤러가 목표값과 센서의 실제값을 실시간으로 비교하고,
              서보밸브가 유압유의 방향과 유량을 정밀하게 조절합니다. 이를 통해
              롤프레스 실린더의 위치·압력·갭을 빠르고 안정적으로 제어합니다.
            </p>
          </div>

          {/* Loop image */}
          <div className="max-w-[1200px] mx-auto mb-12 md:mb-16">
            <div className="rounded-2xl border border-background-200 shadow-lg overflow-hidden bg-background-100">
              <img
                src={LOOP_IMAGE}
                alt="서보밸브 중심 폐루프 제어 시스템 구성도"
                className="w-full h-auto object-contain"
              />
            </div>
          </div>

          {/* Features */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-5xl mx-auto">
            {FEATURES.map((f) => (
              <div key={f.title} className="text-center">
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 mb-2">
                  {f.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {f.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTASection
        title="Servo Hydraulic 시스템 설계가 필요하신가요?"
        description="장비 사양과 제어 요구를 알려주시면 MC TECH 엔지니어가 최적의 구성으로 제안드립니다."
      />
    </SiteLayout>
  );
}